export default __webpack_public_path__ + "static/media/main.041a09a0.png";